import { Injectable } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { CustomerModel } from "src/app/models/customer-model";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { Subject } from "rxjs";
import type { PlatformResponse } from "src/app/interfaces/webservices-interface";

type TApiInputObjct = {
  customer_id?: number | null
  session_token?: string
  clientapp?: string
  return_objects?: number;
};

@Injectable({
  providedIn: "root",
})

export class LobbyApiService {
  private customer: CustomerModel;

  constructor(
    private userSession:UserSessionService,
    private webService: WebservicesService,
    private config: ConfigService,
  ) {
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );
  }

  fetchGamesByLobbyName(lobbyName:string):Subject<PlatformResponse<any>> {
    const obj:TApiInputObjct = {
      clientapp: this.config.getClientApp(),
    }
    if(this.customer?.customerId) {
      obj.customer_id = this.customer?.customerId;
    }
    const session_token = this.userSession.getSessionToken();
    if(session_token) {
      obj.session_token = session_token;
    }

    return this.webService.get(`lobby/${lobbyName}/games`, obj);
  }

  fetchKeywords(lobbyName:string):Subject<PlatformResponse<any>> {
    const obj:TApiInputObjct = {
      clientapp: this.config.getClientApp(),
    }
    if(this.customer?.customerId) {
      obj.customer_id = this.customer?.customerId;
    }
    const session_token = this.userSession.getSessionToken();
    if(session_token) {
      obj.session_token = session_token;
    }
    return this.webService.get(`lobby/${lobbyName}/keywords`, obj);
  }


  public async fetchLobby(): Promise<any> {
    const obj = {
        clientapp: this.config.getClientApp(),
    }
    return this.webService.get('lobby/get-lobbies-keywords', obj).toPromise();
}

  fetchLobbiesKeywords():Subject<PlatformResponse<any>> {
    const obj:TApiInputObjct = {
      clientapp: this.config.getClientApp(),
    }
    if(this.customer?.customerId) {
      obj.customer_id = this.customer?.customerId;
    }
    const session_token = this.userSession.getSessionToken();
    if(session_token) {
      obj.session_token = session_token;
    }
    return this.webService.get('lobby/get-lobbies-keywords',obj);
  }

  fetchLobbiesBanners(lobbyName:string, loggedIn: boolean):Subject<PlatformResponse<any>> {
    const obj:TApiInputObjct = {
      clientapp: this.config.getClientApp(),
    }
    if(loggedIn) {
      obj.customer_id = this.customer.customerId,
      obj.session_token = this.userSession.getSessionToken()
    }
    return this.webService.get( `lobby/${lobbyName}/banners`, obj);
  }

  getFavourites() :Subject<PlatformResponse<any>>{
    if (!this.customer) {
      return new Subject();
    }

    const obj = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
    }

    return this.webService.get("lobby/get-favourite-games", obj);
  }

  getRecent(lobbyName:string, onlyLastPlayed=false):Subject<PlatformResponse<any>> {
    if (!this.customer) {
      return new Subject();
    }
    const obj:TApiInputObjct = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      clientapp: this.config.getClientApp(),
    }
    if(onlyLastPlayed) {
      obj.return_objects = 1
    }

    return this.webService .get(`lobby/${lobbyName}/recent`, obj);
  }

  addFavourites(game_id): Subject<PlatformResponse<any>> {
    if (!this.customer) {
      return new Subject();
    }
    const obj = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      launch_id: game_id,
    }
    return this.webService.post("/lobby/add-favourite-game", obj);
  }

  removeFavourites(game_id):Subject<PlatformResponse<any>> {
    if (!this.customer) {
      return new Subject();
    }
    const obj = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      launch_id: game_id,
    }
    return this.webService.post("lobby/remove-favourite-game", obj);
  }

  removeRecent(game_id) {
    if (!this.customer) {
      return new Subject();
    }
    const obj = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.getSessionToken(),
      launch_id: game_id,
    }
    return this.webService.post("lobby/remove-recent-game", obj);
  }
}
